import { useFormContext } from "react-hook-form";
import { Input } from "../../../../components/ui/input";
import { Label } from "../../../../components/ui/label";
import { FieldError } from "../FieldError";
import { useEffect } from "react";

export function AgentEmail({ control, producers }) {
  const { register, watch, setValue } = useFormContext();
  const producer = watch('step1.producer');
  const agentEmail = watch('step1.agentEmail');
  useEffect(() => {
    const p = producers?.data?.users?.find((p) => p.id === producer);
    if (!agentEmail && p)
      setValue('step1.agentEmail', p.email);
  }, [producer, producers]);
  return (
    <div className="space-y-2">
      <Label htmlFor="agentEmail">Agent Email</Label>
      <Input
        id="agentEmail"
        type="email"
        placeholder="Enter..."
        {...register("step1.agentEmail")}
      />
      <p className="text-sm text-gray-500">
        This agent will receive all correspondence regarding this quote.
      </p>
      <FieldError name="step1.agentEmail" step="step1" control={control} />
    </div>
  )
}